import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="section-container py-12 sm:py-20">
        <Button
          variant="ghost"
          onClick={() => window.history.back()}
          className="mb-8 hover:bg-transparent hover:text-foreground"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>

        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-12">
            Cookie Policy
          </h1>

          <div className="space-y-12 text-left">
            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">1. What Are Cookies</h2>
              <p className="text-base text-muted-foreground leading-relaxed">
                Cookies are small text files that are placed on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and understanding how you use our platform.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">2. How We Use Cookies</h2>
              <p className="text-base text-muted-foreground leading-relaxed mb-4">
                We use cookies for the following purposes:
              </p>
              <ul className="list-disc pl-6 text-base text-muted-foreground leading-relaxed space-y-3">
                <li><strong>Essential Cookies:</strong> Required for the platform to function properly, including authentication and security</li>
                <li><strong>Performance Cookies:</strong> Help us understand how visitors interact with our platform by collecting anonymous usage data</li>
                <li><strong>Functional Cookies:</strong> Remember your preferences and settings</li>
                <li><strong>Analytics Cookies:</strong> Allow us to analyze platform usage and improve our services</li>
              </ul>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">3. Types of Cookies We Use</h2>
              <div className="space-y-6">
                <div>
                  <h3 className="font-medium text-lg text-foreground mb-3">Session Cookies</h3>
                  <p className="text-base text-muted-foreground leading-relaxed">
                    Temporary cookies that expire when you close your browser. These are essential for platform functionality.
                  </p>
                </div>
                <div>
                  <h3 className="font-medium text-lg text-foreground mb-3">Persistent Cookies</h3>
                  <p className="text-base text-muted-foreground leading-relaxed">
                    Remain on your device for a set period or until you delete them. These help us remember your preferences.
                  </p>
                </div>
                <div>
                  <h3 className="font-medium text-lg text-foreground mb-3">Third-Party Cookies</h3>
                  <p className="text-base text-muted-foreground leading-relaxed">
                    Set by third-party services we use, such as analytics providers (e.g., Google Analytics).
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">4. Managing Cookies</h2>
              <p className="text-base text-muted-foreground leading-relaxed mb-4">
                You can control and manage cookies in various ways:
              </p>
              <ul className="list-disc pl-6 text-base text-muted-foreground leading-relaxed space-y-2">
                <li>Browser settings: Most browsers allow you to refuse or accept cookies</li>
                <li>Cookie preference center: Use our cookie settings to manage your preferences</li>
                <li>Third-party opt-out: Visit third-party websites to opt out of their cookies</li>
              </ul>
              <p className="text-base text-muted-foreground leading-relaxed mt-4">
                Please note that blocking all cookies may impact your ability to use certain features of our platform.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">5. Updates to This Policy</h2>
              <p className="text-base text-muted-foreground leading-relaxed">
                We may update this Cookie Policy from time to time. We will notify you of any changes by posting the new policy on this page with an updated "Last updated" date.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">6. Contact Us</h2>
              <p className="text-base text-muted-foreground leading-relaxed">
                If you have questions about our use of cookies, please contact us at:
              </p>
              <p className="text-base text-muted-foreground leading-relaxed mt-4">
                Email: info@smarttenderai.com<br />
                Phone: +44 20 3976 0700<br />
                Address: 3 Shortlands, London W6 8DA, UK
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
